import React from "react";
import { Box, Typography, Paper } from "@mui/material";
import { AlertTriangle } from "lucide-react";

export default function NotFoundPage() {
  return (
    <Box
      display="flex"
      justifyContent="center"
      alignItems="center"
      height="100vh"
      bgcolor="#f5f7fa"
      p={3}
    >
      <Paper
        elevation={6}
        sx={{
          p: 6,
          maxWidth: 500,
          textAlign: "center",
          borderRadius: "10px",
        }}
      >
        <AlertTriangle size={64} style={{ color: "#ff9800" }} />

        <Typography variant="h2" fontWeight={700} mt={2}>
          404
        </Typography>

        <Typography variant="h5" color="text.secondary" mt={1}>
          Página no encontrada
        </Typography>

        <Typography variant="body1" color="text.secondary" mt={2} mb={4}>
          La página que estás buscando no existe o fue movida. Por favor revisa
          la URL o vuelve al inicio.
        </Typography>
      </Paper>
    </Box>
  );
}
